import { baseMenu, chatMenu, ordersMenu, directoryMenu, controlMenu, cloneMenu, settingsMenu, reportsMenu } from './menuParts';

export const menuConfig = {
  Programmer: [
    { heading: "Programmer" },
    ...baseMenu,
    chatMenu,
    ordersMenu,
    directoryMenu,
    controlMenu,
    { icon: "mdi-account-cash", text: "partnerControl", link: "PartnerControl" },
    reportsMenu,
    settingsMenu
  ],
  Pharmacy: [
    ...baseMenu,
    chatMenu,
    cloneMenu(ordersMenu, ['adminarchive']),
    cloneMenu(directoryMenu, ["cities", "users"]),
    settingsMenu
  ],
  Pharmacy_administrator: [
    ...baseMenu,
    chatMenu,
    ordersMenu,
    directoryMenu,
    cloneMenu(reportsMenu)
  ],
  Pharmacy_center: [
        ...baseMenu,
    chatMenu,
    ordersMenu,
    cloneMenu(directoryMenu, ["users"]),
    settingsMenu
  ],
  Filial: [
    { heading: "Filial" },
    { icon: "mdi-home", text: "main", link: "/" },
    chatMenu,
    cloneMenu(directoryMenu, ["cities", "suppliers", "goods", "annotation", "users"]), // только цены
    cloneMenu(reportsMenu, ["priceMonitoring"])
  ],
  Filial_administrator: [
    { heading: "Filial_administrator" },
    { icon: "mdi-home", text: "main", link: "/" },
    chatMenu,
    cloneMenu(directoryMenu, ["cities", "suppliers", "goods", "annotation", "users"]), // только цены
    cloneMenu(reportsMenu, ["priceMonitoring"])
  ],
  Producer: [],
  Producer_administrator: [],
  Manager: [
    { heading: "MANAGER" },
    ...baseMenu,
    chatMenu,
    ordersMenu,
    directoryMenu,
    cloneMenu(controlMenu, ["access", "Hangfire"]),
    { icon: "mdi-account-cash", text: "partnerControl", link: "PartnerControl" },
    reportsMenu
  ],
  Regional_partner: [
    { icon: "mdi-handshake", text: "partnerCabinet", link: "PartnerCabinet" },
    ...baseMenu,
    chatMenu,
    cloneMenu(ordersMenu, ['adminarchive']),
    cloneMenu(directoryMenu, ["cities", "users"]),
    settingsMenu
  ],
  Accountant: [
    {
      chatMenu,
      icon: "mdi-chevron-up",
      "icon-alt": "mdi-chevron-down",
      text: "Управление",
      model: false,
      children: [
        { icon: "mdi-newspaper-variant-outline", text: "Контроллер", link: "UserAccessControl" }
      ]
    }
  ]
};